var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14287_59309",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14287_59309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1166 13.5305C12.0966 13.5305 12.0666 13.5305 12.0466 13.5305C12.0166 13.5305 11.9766 13.5305 11.9466 13.5305C9.67656 13.4605 7.97656 11.6905 7.97656 9.51047C7.97656 7.29047 9.78656 5.48047 12.0066 5.48047C14.2266 5.48047 16.0366 7.29047 16.0366 9.51047C16.0266 11.7005 14.3166 13.4605 12.1466 13.5305C12.1266 13.5305 12.1266 13.5305 12.1166 13.5305ZM11.9966 6.97047C10.5966 6.97047 9.46656 8.11047 9.46656 9.50047C9.46656 10.8705 10.5366 11.9805 11.8966 12.0305C11.9266 12.0205 12.0266 12.0205 12.1266 12.0305C13.4666 11.9605 14.5166 10.8605 14.5266 9.50047C14.5266 8.11047 13.3966 6.97047 11.9966 6.97047Z",
    fill: "#1D1B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 22.7503C9.31081 22.7503 6.74081 21.7503 4.75081 19.9303C4.57081 19.7703 4.49081 19.5303 4.51081 19.3003C4.64081 18.1103 5.38081 17.0003 6.61081 16.1803C9.59081 14.2003 14.4208 14.2003 17.3908 16.1803C18.6208 17.0103 19.3608 18.1103 19.4908 19.3003C19.5208 19.5403 19.4308 19.7703 19.2508 19.9303C17.2608 21.7503 14.6908 22.7503 12.0008 22.7503ZM6.08081 19.1003C7.74081 20.4903 9.83081 21.2503 12.0008 21.2503C14.1708 21.2503 16.2608 20.4903 17.9208 19.1003C17.7408 18.4903 17.2608 17.9003 16.5508 17.4203C14.0908 15.7803 9.92081 15.7803 7.44081 17.4203C6.73081 17.9003 6.26081 18.4903 6.08081 19.1003Z",
    fill: "#1D1B20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z",
    fill: "#1D1B20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.48727fed76624e8252e4f8e00b93e2d0.svg";
export { ForwardRef as ReactComponent };